import { Box } from '@betterment/samba-react';

export const HiddenChartDescription = ({ id, children }: { id: string; children: React.ReactNode }) => {
  return (
    <Box id={id} css={{ srOnly: true }}>
      {children}
    </Box>
  );
};
